import {
  CLEAR_ALL_PROGRESS,
  STORE_PROGRESS,
  STORE_PROGRESS_UPDOWNVOTE,
  STORE_PROGRESS_CONTENT,
  STORE_PROGRESS_CONTENT_LAST_SEEN,
  STORE_PROGRESS_PROBLEMS_TRIED,
  STORE_PROGRESS_ELAPSED_TIME,
  STORE_PROGRESS_REVIEW_PROGRESS,
  STORE_PROGRESS_ADD_BOOKMARK,
  STORE_PROGRESS_EDIT_BOOKMARK,
  STORE_PROGRESS_DELETE_BOOKMARK,
  STORE_PROGRESS_NOTES,
  STORE_PROGRESS_ADD_HIGHLIGHT,
  STORE_PROGRESS_DELETE_HIGHLIGHT,
} from "../constants/actionConstants";
import {
  UPDATE_COMMENTS_USED,
  UPDATE_CONCEPTS_USED,
  UPDATE_EQUATIONS_USED,
  UPDATE_NOTES_USED,
} from "../constants/userConstants";

// Updates store with the progress that we have made for this content
const ProgressReducer = (
  state = {
    userId: "",
    courseId: "",
    contentSeen: [],
    contentLastSeen: "",
    problemsTried: [],
    notes: [],
    feedback: [],
    upDownVotes: [],
    dateStarted: "",
    dateLastSeen: "",
    elapsedTime: -1,
    elapsedTimeCopy: -1,
    showProblems: true,
    reviewProgress: false,
    highlights: [],
    bookmarks: [],
    conceptsUsed: true,
    notesUsed: true,
    commentsUsed: true,
    equationsUsed: true,
  },
  action,
) => {
  // Elapsed time is loaded from the database
  // Elapsed time copy is updated continually
  switch (action.type) {
    // Resets when we change user
    case CLEAR_ALL_PROGRESS:
      return {
        userId: "",
        courseId: "",
        contentSeen: [],
        contentLastSeen: "",
        problemsTried: [],
        feedback: [],
        upDownVotes: [],
        dateStarted: "",
        dateLastSeen: "",
        elapsedTime: -1,
        elapsedTimeCopy: -1,
        showProblems: true,
        reviewProgress: false,
        conceptsUsed: true,
        notesUsed: true,
        commentsUsed: true,
        equationsUsed: true,
        highlights: [],
        bookmarks: [],
      };
    case STORE_PROGRESS:
      // This reducer only called when initially load page
      // Check if this was more than 16 hours ago and flag to review progress if so
      const day = 16 * 1000 * 60 * 60;
      const review_progress =
        Date.parse(action.payload.dateLastSeen) < Date.now() - day;
      // return {...action.payload, reviewProgress:review_progress}

      return { ...state, ...action.payload, reviewProgress: review_progress };
    case STORE_PROGRESS_UPDOWNVOTE:
      return { ...state, upDownVotes: action.payload };
    case STORE_PROGRESS_CONTENT:
      // If we've seen this before, just update last seen time and last seen object
      if (
        state.contentSeen.some(
          (elem) => elem === action.payload.contentLastSeen,
        )
      ) {
        return {
          ...state,
          dateLastSeen: Date.now(),
          contentLastSeen: action.payload.contentLastSeen,
        };
      }
      // Haven't seen so also add to list
      else {
        let contentSeen = structuredClone(state.contentSeen);
        contentSeen.push(action.payload.contentLastSeen);
        return {
          ...state,
          dateLastSeen: Date.now(),
          contentLastSeen: action.payload.contentLastSeen,
          contentSeen: contentSeen,
        };
      }
    case STORE_PROGRESS_CONTENT_LAST_SEEN:
      return {
        ...state,
        dateLastSeen: Date.now(),
        contentLastSeen: action.payload.contentLastSeen,
      };
    case STORE_PROGRESS_NOTES:
      return { ...state, notes: action.payload };
    case STORE_PROGRESS_PROBLEMS_TRIED:
      return { ...state, problemsTried: action.payload };
    case STORE_PROGRESS_ELAPSED_TIME:
      return { ...state, elapsedTimeCopy: action.payload };
    case STORE_PROGRESS_REVIEW_PROGRESS:
      return { ...state, reviewProgress: action.payload };
    case STORE_PROGRESS_ADD_BOOKMARK:
      var bookmarks_copy_add = structuredClone(state.bookmarks);
      bookmarks_copy_add.push(action.payload);
      return { ...state, bookmarks: bookmarks_copy_add };
    case STORE_PROGRESS_DELETE_BOOKMARK:
      var bookmarks_copy_delete = structuredClone(state.bookmarks);
      bookmarks_copy_delete = bookmarks_copy_delete.filter(
        (a) => a._id !== action.payload,
      );
      return { ...state, bookmarks: bookmarks_copy_delete };
    case STORE_PROGRESS_EDIT_BOOKMARK:
      var bookmarks_copy_edit = structuredClone(state.bookmarks);
      const bookmark_index = bookmarks_copy_edit.findIndex(
        (a) => a._id === action.payload._id,
      );
      bookmarks_copy_edit[bookmark_index] = action.payload;
      return { ...state, bookmarks: bookmarks_copy_edit };
    case STORE_PROGRESS_ADD_HIGHLIGHT:
      return { ...state, highlights: [...state.highlights, action.payload] };
    case STORE_PROGRESS_DELETE_HIGHLIGHT:
      return {
        ...state,
        highlights: state.highlights.filter((h) => h.id !== action.payload),
      };
    case UPDATE_CONCEPTS_USED:
      return { ...state, conceptsUsed: true };
    case UPDATE_NOTES_USED:
      return { ...state, notesUsed: true };
    case UPDATE_COMMENTS_USED:
      return { ...state, commentsUsed: true };
    case UPDATE_EQUATIONS_USED:
      return { ...state, equationsUsed: true };

    default:
      return state;
  }
};

export default ProgressReducer;
